import { render, staticRenderFns } from "./patientinoperation.vue?vue&type=template&id=fb6c10c2&scoped=true&"
import script from "./patientinoperation.vue?vue&type=script&lang=js&"
export * from "./patientinoperation.vue?vue&type=script&lang=js&"
import style0 from "./patientinoperation.vue?vue&type=style&index=0&id=fb6c10c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6c10c2",
  null
  
)

export default component.exports